<template>
  <div class="root-container">
    <div class="table-container">
    <!-- 搜索栏（固定） -->
    <div class="search-container" :class="{ 'mobile-search-top': !isDesktop }">
      <!-- 电脑端使用 Element UI 搜索框 -->
      <div v-if="isDesktop" class="desktop-search-wrapper">
        <div class="search-row">
          <el-input 
            v-model="searchKeyword" 
            placeholder="请输入菜单名称搜索" 
            clearable
            size="small"
            class="search-input"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
          <div class="button-group">
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-plus" 
              @click="handleOpenAdd"
              class="add-button"
            >
              添加菜单
            </el-button>
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-filter" 
              @click="toggleFilter"
              class="filter-button"
            >
              {{ isFilterOpen ? '收起筛选' : '展开筛选' }}
            </el-button>
          </div>
        </div>
        
        <!-- 电脑端筛选面板 -->
        <div v-if="isFilterOpen" class="filter-panel">
          <div class="filter-row">
            <div class="filter-item">
              <label>是否启用：</label>
              <el-select v-model="filterForm.enable" placeholder="请选择状态" clearable size="small" style="width: 120px;">
                <el-option label="全部" value=""></el-option>
                <el-option label="已启用" value="1"></el-option>
                <el-option label="未启用" value="0"></el-option>
              </el-select>
            </div>
          </div>
          <div class="filter-actions">
            <div class="applied-filters">
              <span v-if="appliedFilterForm.enable" class="filter-tag">
                是否启用: {{ appliedFilterForm.enable === '1' ? '已启用' : '未启用' }}
              </span>
              <span v-if="!appliedFilterForm.enable" class="filter-tag filter-tag-empty">
                当前无筛选条件
              </span>
            </div>
            <div class="filter-buttons">
              <el-button size="small" @click="resetFilter">重置筛选</el-button>
              <el-button type="primary" size="small" @click="applyFilter">应用筛选</el-button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 手机端使用 Vant 搜索框 -->
      <div v-else class="mobile-search-wrapper">
        <van-search
          v-model="searchKeyword"
          placeholder="请输入菜单名称搜索"
          show-action
          @search="handleSearch"
          @cancel="onSearchCancel"
          :placeholder-style="{ fontSize: '16px' }"
          :input-align="'center'"
        >
          <template #action>
            <div @click="handleSearch" style="margin-right: 10px; font-size: 16px; color: var(--primary); font-weight: 600;">搜索</div>
          </template>
        </van-search>
        
        <!-- 手机端添加按钮 -->
        <div class="mobile-add-button">
          <van-button 
            type="primary" 
            size="small" 
            block
            icon="plus"
            @click="handleOpenAdd"
            style="margin-top: 10px;"
          >
            添加菜单
          </van-button>
        </div>
        
        <!-- 手机端筛选面板 -->
        <div v-if="isFilterOpen" class="mobile-filter-panel">
          <!-- 手机端已应用筛选条件显示 -->
          <div class="mobile-applied-filters">
            <div v-if="appliedFilterForm.enable" class="applied-title">已应用筛选条件：</div>
            <div class="applied-tags">
              <span v-if="appliedFilterForm.enable" class="mobile-filter-tag">
                是否启用: {{ appliedFilterForm.enable === '1' ? '已启用' : '未启用' }}
              </span>
              <span v-if="!appliedFilterForm.enable" class="mobile-filter-tag empty">
                当前无筛选条件
              </span>
            </div>
          </div>
          
          <van-cell title="是否启用" is-link @click="showEnablePicker = true">{{ appliedFilterForm.enable === '1' ? '已启用' : appliedFilterForm.enable === '0' ? '未启用' : '全部' }}</van-cell>
          <div class="mobile-filter-actions">
            <van-button type="default" size="small" @click="resetFilter">重置</van-button>
            <van-button type="primary" size="small" @click="applyFilter">应用</van-button>
          </div>
        </div>
        
        <!-- 手机端筛选展开按钮 -->
        <div class="mobile-filter-toggle" @click="toggleFilter">
          <van-icon :name="isFilterOpen ? 'arrow-up' : 'arrow-down'" /> 
          <span>{{ isFilterOpen ? '收起筛选' : '展开筛选' }}</span>
        </div>
      </div>
    </div>
    
    <!-- 内容区域（可滚动） -->
    <div class="content-container">
      
      <!-- 电脑端表格 -->
      <div class="table-wrapper" v-if="isDesktop">
        <el-table 
          :data="filteredData" 
          style="width: 100%" 
          tooltip-effect="dark" 
          empty-text="暂无数据"
          class="desktop-table"
          :height="tableHeight"
        >
          <el-table-column label="排序" prop="sort" align="left" width="80px"></el-table-column>
          <el-table-column label="名称" prop="name" align="left" width="180px">
            <template slot-scope="scope">
              <span v-if="scope.row.parent_id>0">　　|-{{scope.row.name}}</span>
              <span v-else>{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="标识" prop="menu_id" align="left" width="240px"></el-table-column>
          <el-table-column label="URL" prop="url" align="left" width="200px"></el-table-column>
          <el-table-column label="是否启用" prop="enable" align="left" width="220px">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.enable_bool"
                active-text="已启用"
                size="small"
                inactive-text="未启用"
                @change="changeEnable(scope.row.enable_bool,scope.row)  "
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="right" fixed="right" width="220px">
            <template slot-scope="scope">
              <div class="table-actions">
                <el-link @click="addChild(scope.row)" v-if="scope.row.parent_id === 0"><i class="el-icon-sort-down"></i>子菜单</el-link>
                <el-link @click="editChild(scope.row)">
                  <i class="el-icon-edit" style="font-size:16px;"></i>编辑
                </el-link>
                <el-dropdown @command="command($event, scope.row)">
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="remove" v-if="scope.row.menu_id !== 'system_management'">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 手机端卡片 -->
      <div v-else class="mobile-cards">
        <div 
          v-for="item in filteredData" 
          :key="item.id" 
          class="mobile-card"
        >
          <div class="card-header">
            <h3>{{ item.parent_id > 0 ? '　　|-' + item.name : item.name }}</h3>
            <el-tag :type="item.enable_bool ? 'success' : 'danger'" size="small">
              {{ item.enable_bool ? '已启用' : '未启用' }}
            </el-tag>
          </div>
          <div class="card-content">
            <p><strong>标识:</strong> {{ item.menu_id }}</p>
            <p><strong>URL:</strong> {{ item.url || '-' }}</p>
            <p><strong>排序:</strong> {{ item.sort }}</p>
          </div>
          <div class="card-actions">
            <van-button 
              v-if="item.parent_id === 0"
              type="default" 
              size="small" 
              plain
              icon="plus"
              @click="addChild(item)"
              style="margin-right: 10px;"
            >
              子菜单
            </van-button>
            <van-button 
              type="primary" 
              size="small" 
              plain
              icon="edit"
              @click="editChild(item)"
              style="margin-right: 10px;"
            >
              编辑
            </van-button>
            <van-button 
              v-if="item.menu_id !== 'system_management'"
              type="danger" 
              size="small" 
              plain
              icon="delete"
              @click="handleDelete(item.id)"
            >
              删除
            </van-button>
          </div>
        </div>
        
        <!-- 手机端空状态 -->
        <div v-if="filteredData.length === 0" class="mobile-empty">
          暂无数据
        </div>
      </div>
    </div>
    
    <!-- 分页（固定） -->
    <!-- <div class="pagination-container">
      <el-pagination
        v-if="isDesktop"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="filteredData.length"
      ></el-pagination>
      
      <el-pagination
        v-else
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 15]"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="filteredData.length"
        small
      ></el-pagination>
    </div> -->
    
    <!-- 手机端选择器弹窗 -->
    <van-popup v-model="showEnablePicker" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        get-container="body"
        :columns="enableColumns"
        @confirm="onEnableConfirm"
        @cancel="showEnablePicker = false"
      />
    </van-popup>
    
    <!-- 添加/编辑抽屉 - 电脑端 -->
    <el-drawer v-if="isDesktop" title="添加菜单" :visible.sync="addDrawer" :direction="direction" :before-close="handleClose">
      <add-comp @close="handleClose" @success="handleDrawerSuccess" :parent_id="addSonMenu.parent_id" :parent_name="addSonMenu.parent_name" ref="newForm" v-if="addDrawer"></add-comp>
    </el-drawer>
    
    <el-drawer v-if="isDesktop" title="更改菜单" :visible.sync="editDrawer" :direction="direction" :before-close="handleClose">
      <edit-comp @close="handleClose" @success="handleDrawerSuccess" :id="editMenu.id" :changeInfo="changeInfo" ref="newForm" v-if="editDrawer"></edit-comp>
    </el-drawer>
    
  </div>
  
  <!-- 添加/编辑弹窗 - 手机端 -->
  <van-popup
    v-if="!isDesktop" 
    v-model="addPopup" 
    position="bottom" 
    :round="true"
    :close-on-click-overlay="false"
    :lock-scroll="true"
    get-container="body"
    style="max-height:80%"
    @open="handlePopupOpen"
    @close="handlePopupClose"
  >
    <div class="popup-container">
      <div class="popup-header">
        <h3>添加菜单</h3>
        <van-icon name="cross" @click="handleClosePopup('add')" class="close-icon" />
      </div>
      <div class="popup-content">
        <add-comp @close="handleClosePopup('add')" @success="handlePopupSuccess" :parent_id="addSonMenu.parent_id" :parent_name="addSonMenu.parent_name" ref="newForm"></add-comp>
      </div>
    </div>
  </van-popup>
  
  <van-popup
    v-if="!isDesktop" 
    v-model="editPopup" 
    position="bottom" 
    :round="true"
    :close-on-click-overlay="false"
    :lock-scroll="true"
    get-container="body"
    style="max-height:80%"
    @open="handlePopupOpen"
    @close="handlePopupClose"
  >
    <div class="popup-container">
      <div class="popup-header">
        <h3>更改菜单</h3>
        <van-icon name="cross" @click="handleClosePopup('edit')" class="close-icon" />
      </div>
      <div class="popup-content">
        <edit-comp @close="handleClosePopup('edit')" @success="handlePopupSuccess" :id="editMenu.id" :changeInfo="changeInfo" ref="newForm"></edit-comp>
      </div>
    </div>
  </van-popup>
</div>
</template>

<script>
// 静态导入 Vant 弹框组件
import { Dialog, Toast, Icon } from 'vant'
import {getMenus,deleteMenu,updateMenu} from '@/api/system'
import editComp from "./components/edit.vue";
import addComp from "./components/add.vue";

export default {
  name: "newindex",
  components: { addComp, editComp, [Icon.name]: Icon },
  data() {
    return {
      // 搜索相关
      searchKeyword: '',
      currentPage: 1,
      pageSize: 10,
      isDesktop: true,
      // 筛选相关
      isFilterOpen: false,
      filterForm: {
        enable: ''
      },
      // 保存已应用的筛选条件
      appliedFilterForm: {
        enable: ''
      },
      // 手机端选择器
      showEnablePicker: false,
      enableColumns: ['全部', '已启用', '未启用'],
      
      // 表格数据
      tableData: [],
      direction: "rtl",
      
      // 抽屉/弹窗控制
      addDrawer: false,
      editDrawer: false,
      addPopup: false,
      editPopup: false,
      
      // 菜单数据
      addSonMenu: {
        parent_id: 0,
        parent_name: ''
      },
      editMenu: {
        id: 0
      },
      changeInfo: ""
    };
  },
  computed: {
    filteredData() {
      return this.tableData.filter(item => {
        // 关键词搜索
        const keyword = this.searchKeyword.toLowerCase()
        const matchesKeyword = !keyword || item.name.toLowerCase().includes(keyword)
        
        // 启用状态筛选
        const matchesEnable = !this.filterForm.enable || item.enable.toString() === this.filterForm.enable
        
        return matchesKeyword && matchesEnable
      })
    },
    tableHeight() {
      if (!this.isDesktop) return 'auto'
      // 计算表格高度：减去顶部栏、筛选区域、分页栏和底部的高度
      const headerHeight = 60 // 顶部栏高度
      const searchHeight = this.isFilterOpen ? 180 : 60 // 搜索栏高度（包含筛选面板）
      const paginationHeight = 0 // 分页栏高度
      const footerHeight = 40 // 底部高度
      const padding = 20 // 页面内边距
      return window.innerHeight - headerHeight - searchHeight - paginationHeight - footerHeight - padding - 100 // 100是其他元素的额外高度
    }
  },
  methods: {
    // 初始化数据
    initData() {
      this.getTableData()
    },
    
    // 获取表格数据
    getTableData() {
      getMenus({}).then(res=>{
        if (res.code === 200){
          let tmp = []
          res.data.forEach((value,key) => {
            tmp[key] = value
            tmp[key]['enable_bool'] = value.enable ? true : false
          })
          this.tableData = tmp
        }
      })
    },
    
    // 处理搜索
    handleSearch() {
      this.currentPage = 1
    },
    
    // 检查屏幕大小
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    
    // 处理窗口大小变化
    handleResize() {
      this.checkScreenSize()
    },
    
    // 处理添加按钮点击
    handleOpenAdd() {
      this.addSonMenu = {
        parent_id: 0,
        parent_name: ''
      }
      if (this.isDesktop) {
        this.addDrawer = true
      } else {
        this.addPopup = true
      }
    },
    
    // 切换筛选面板
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen
    },
    
    // 应用筛选
    applyFilter() {
      // 保存当前筛选条件为已应用条件
      this.appliedFilterForm = JSON.parse(JSON.stringify(this.filterForm))
      this.currentPage = 1
    },
    
    // 重置筛选
    resetFilter() {
      // 初始化筛选条件
      const initialFilter = {
        enable: ''
      }
      // 同时重置当前筛选表单和已应用筛选条件
      this.filterForm = JSON.parse(JSON.stringify(initialFilter))
      this.appliedFilterForm = JSON.parse(JSON.stringify(initialFilter))
      this.currentPage = 1
    },
    
    // 手机端启用状态选择确认
    onEnableConfirm(value) {
      const enableMap = {
        '全部': '',
        '已启用': '1',
        '未启用': '0'
      }
      this.filterForm.enable = enableMap[value]
      this.showEnablePicker = false
      this.applyFilter()
    },
    
    // 修改启用状态
    changeEnable(status,row){
      this.$confirm('确认修改数据吗？')
          .then(_ => {
              updateMenu(row.id,{"enable": status ? 1 : 0}).then(res=>{
                this.getTableData()
                if(res.code===200){
                  this.$notify({
                  title: '成功',
                  message: '修改成功',
                  type: 'success'
                });
                }
              })
          })
          .catch(_ => {});
    },
    
    // 删除菜单
    handleDelete(id) {
      if (this.isDesktop) {
        this.$confirm('删除后无法恢复，请慎重考虑，确认删除数据吗？')
          .then(_ => {
              deleteMenu(id).then(res=>{
                this.getTableData()
                this.$notify({
                  title: '成功',
                  message: '删除成功',
                  type: 'success'
                });
              })
          })
          .catch(_ => {});
      } else {
        Dialog.confirm({
          title: '提示',
          message: '删除后无法恢复，请慎重考虑，确认删除数据吗？',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
        .then(() => {
          deleteMenu(id).then(res=>{
            this.getTableData()
            Toast({
              message: '删除成功',
              type: 'success',
              duration: 2000
            })
          })
        })
        .catch(() => {
          // 取消删除
        })
      }
    },
    
    // 添加子菜单
    addChild(value='') {
      if(value){
        this.addSonMenu = {
          parent_id : value.id,
          parent_name: value.menu_id
        }
      }
      
      if (this.isDesktop) {
        this.addDrawer = true
      } else {
        this.addPopup = true
      }
    },
    
    // 编辑菜单
    editChild(value){
      this.editMenu = {
        id : value.id,
      }
      this.changeInfo = value
      
      if (this.isDesktop) {
        this.editDrawer = true
      } else {
        this.editPopup = true
      }
    },
    
    // 关闭添加/修改 - 电脑端
    handleClose() {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.addDrawer = false;
          this.editDrawer = false;
        })
        .catch((_) => { });
    },
    
    // 关闭弹窗 - 手机端
    handleClosePopup(type) {
      Dialog.confirm({
        title: '提示',
        message: '确认关闭？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
      .then(() => {
        if (type === 'add') {
          this.addPopup = false;
        } else if (type === 'edit') {
          this.editPopup = false;
        }
      })
      .catch(() => {
        // 取消关闭
      })
    },
    
    // 弹窗打开时禁止页面滚动
    handlePopupOpen() {
      document.body.style.overflow = 'hidden';
    },
    
    // 弹窗关闭时恢复页面滚动
    handlePopupClose() {
      document.body.style.overflow = '';
    },
    
    // 添加/修改成功 - 电脑端
    handleDrawerSuccess() {
      this.addDrawer = false;
      this.editDrawer = false;
      this.getTableData();
    },
    
    // 添加/修改成功 - 手机端
    handlePopupSuccess() {
      this.addPopup = false;
      this.editPopup = false;
      this.getTableData();
    },
    
    // 分页相关
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    
    // 处理 Vant 搜索框取消事件
    onSearchCancel() {
      this.searchKeyword = ''
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.handleResize)
    this.initData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>
/* 使用全局样式中定义的 CSS 变量 */
.root-container{
  height: 100%;
}
.table-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 搜索栏（固定） */
.search-container {
  margin-bottom: 0;
  padding: 20px;
  background-color: var(--background);
  border-radius: var(--border-radius);
  box-sizing: border-box;
  transition: all 0.3s ease;
}

/* 手机端搜索置顶 */
.mobile-search-top {
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
  padding: 10px 15px;
}

/* 电脑端搜索容器 */
.desktop-search-wrapper {
  width: 100%;
}

.search-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-input {
  width: 100%;
  max-width: 400px;
  font-size: var(--font-size-sm);
}

.filter-button {
  white-space: nowrap;
}

/* 按钮组样式 */
.button-group {
  display: flex;
  align-items: center;
}

.add-button {
  white-space: nowrap;
}

/* 手机端添加按钮样式 */
.mobile-add-button {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

/* 筛选面板 */
.filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  padding: 15px;
  margin-top: 10px;
  box-shadow: var(--shadow);
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 筛选操作区域 */
.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid var(--border);
}

/* 已应用筛选标签容器 */
.applied-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

/* 单个筛选标签样式 */
.filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: var(--font-size-sm);
  display: inline-flex;
  align-items: center;
}

/* 空状态筛选标签 */
.filter-tag-empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 筛选按钮容器 */
.filter-buttons {
  display: flex;
  gap: 10px;
}

.filter-item label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text);
}

/* 手机端已应用筛选条件样式 */
.mobile-applied-filters {
  padding: 10px 15px;
  background-color: var(--bg-100);
  border-radius: var(--border-radius);
  margin-bottom: 15px;
}

.mobile-applied-filters .applied-title {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--text);
  margin-bottom: 8px;
}

.mobile-applied-filters .applied-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mobile-filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: var(--font-size-xs);
  display: inline-block;
}

.mobile-filter-tag.empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 手机端筛选操作按钮区域 */
.mobile-filter-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 0;
  margin-top: 10px;
  border-top: 1px solid var(--border);
}

/* 手机端搜索容器 */
.mobile-search-wrapper {
  width: 100%;
}

/* 手机端筛选面板 */
.mobile-filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  margin-top: 10px;
  overflow: hidden;
}

/* 手机端筛选展开按钮 */
.mobile-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px;
  margin-top: 10px;
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  color: var(--text-200);
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-filter-toggle:hover {
  background-color: var(--border-light);
}

/* 内容区域（可滚动） */
.content-container {
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding: 20px 0;
  padding-bottom: 0;
}

/* 电脑端表格 */
.table-wrapper {
  height: 100%;
  margin-bottom: 0;
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: var(--shadow);
  font-size: 14px;
}

.table-actions{
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  gap: 10px;
  font-size: 14px;
}

.desktop-table {
  height: 100%;
  margin-bottom: 0;
  font-size: 14px;
}

/* 手机端卡片 */
.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 0;
}

.mobile-card {
  border: 1px solid var(--border);
  border-radius: var(--border-radius-lg);
  padding: 15px;
  background-color: var(--bg-200);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
}

.mobile-card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-light);
}

.card-header h3 {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-content {
  border-bottom: 1px solid var(--border-light);
  padding-bottom: 12px;
  margin-bottom: 12px;
}

.card-content p {
  margin: 8px 0;
  font-size: var(--font-size-sm);
  color: var(--text-200);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  line-height: 1.6;
  flex-wrap: wrap;
}

.card-content p strong {
  color: var(--text);
  font-weight: 500;
  min-width: 80px;
  text-align: left;
  flex-shrink: 0;
}

.card-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 12px;
  flex-wrap: wrap;
  align-items: center;
}

/* Vant按钮样式优化 */
.card-actions .van-button {
  font-size: 13px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

/* 手机端空状态 */
.mobile-empty {
  text-align: center;
  padding: 40px 0;
  color: var(--text-200);
  font-size: var(--font-size-sm);
}

/* 适配小屏幕，确保操作按钮不会换行 */
@media (max-width: 375px) {
  .card-actions {
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  }
  
  .card-actions .van-button {
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 8px;
  }
}

/* 手机端弹窗样式 */
.popup-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--background);
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: var(--background);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 10;
}

.popup-header h3 {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text);
}

.popup-header .close-icon {
  font-size: 20px;
  color: var(--text-200);
  cursor: pointer;
  transition: color 0.2s ease;
}

.popup-header .close-icon:hover {
  color: var(--text);
}

.popup-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background-color: var(--background);
}

/* 筛选面板样式 */
.mobile-filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  margin-top: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.mobile-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px;
  background-color: var(--background);
}

/* 分页（固定） */
.pagination-container {
  margin-top: 0;
  margin-bottom: 0;
  padding: 10px;
  border-top: 1px solid var(--border);
  text-align: right;
  box-sizing: border-box;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content-container {
    padding: 10px 0;
  }
  
  .search-input {
    max-width: 100%;
  }
  
  .pagination-container {
    text-align: center;
    padding: 15px;
  }
  
  .filter-row {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  
  .filter-item {
    width: 100%;
  }
  
  .filter-item .el-select {
    width: 100% !important;
  }
}

@media (min-width: 769px) {
  .mobile-filter-toggle {
    display: none;
  }
  
  .desktop-table {
    display: block;
  }
  
  .mobile-cards {
    display: none;
  }
}

@media (max-width: 768px) {
  .search-container{
    width: 100vw;
    margin-left: -15px;
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
    background-color: var(--bg-200);
  }
  .van-search{
    padding:0;
  }
  .desktop-table {
    display: none;
  }
  
  .mobile-cards {
    display: flex;
  }
  
  .search-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .search-input {
    max-width: 100%;
  }
}
</style>